/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileCommitmentsWithOrder } from '../../models/profile-commitments-with-order';

export interface UpdateCommitmentsOrderForProfile$Params {
  id: number;
      body: ProfileCommitmentsWithOrder
}

export function updateCommitmentsOrderForProfile(http: HttpClient, rootUrl: string, params: UpdateCommitmentsOrderForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileCommitmentsWithOrder>> {
  const rb = new RequestBuilder(rootUrl, updateCommitmentsOrderForProfile.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileCommitmentsWithOrder>;
    })
  );
}

updateCommitmentsOrderForProfile.PATH = '/rest/profile/{id}/commitment/order';
